export default "__VITE_ASSET__C1L2j0zq__"